module.exports = __webpack_public_path__ + "media/images/new-ui-images/dollar-icon-b5655392106b025bdebc9cdcdc4ff8b9.svg";